import { useQuery, queryOptions, useMutation } from "@tanstack/react-query";
import {
	getTransactionPreview,
	TransactionPreviewResponse,
	validatePromoCode,
} from "@/api/transactions.ts";
import { QueryOptionsWithoutKeyAndFn } from "@/types/types";

export const getTransactionPreviewOptions = (
	transferAmount: number,
	locationId: number,
	promoCode: string,
	options?: QueryOptionsWithoutKeyAndFn<TransactionPreviewResponse>,
) =>
	queryOptions({
		queryKey: ["transactionPreview", transferAmount, locationId, promoCode],
		queryFn: async () => {
			return await getTransactionPreview(
				{
					requesting_amount: transferAmount,
					promo_code: promoCode,
				},
				locationId,
			);
		},
		...options,
	});

const useTransactionPreview = (
	transferAmount: number,
	locationId: number,
	promoCode: string,
	options?: QueryOptionsWithoutKeyAndFn<TransactionPreviewResponse>,
) => {
	return useQuery(
		getTransactionPreviewOptions(
			transferAmount,
			locationId,
			promoCode,
			options,
		),
	);
};

export const useValidatePromoCode = (locationId: number) => {
	return useMutation({
		mutationFn: async ({
			promoCode,
			requestingAmount,
		}: {
			promoCode: string;
			requestingAmount: number;
		}) => {
			return await validatePromoCode(promoCode, locationId, requestingAmount);
		},
	});
};

export default useTransactionPreview;
